import React, { Component } from 'react';
import {Text, View, ImageBackground, Image, TouchableOpacity, Linking } from 'react-native';
import Header from './Header';
import Bowser from "bowser";
import ApplicationStyles from './ApplicationStyles';


export default class App extends Component {

  render() {
    return (
        <View style={ApplicationStyles.mainContainer}>
            <ImageBackground source={require('./Images/background1.jpg')}>
                {process.env.NODE_ENV === "development"? <Header/>:<View/>}
                <View style={ApplicationStyles.RowContainer}>
                    <View style={ApplicationStyles.LeftContainer}>
                        <Image style={ApplicationStyles.phone} source={require('./Images/Iphonex.png')}/>
                    </View>

                    <View style={ApplicationStyles.RightContainer}>
                        <View style={ApplicationStyles.TextContainer}>
                            <Text style={ApplicationStyles.logoText}>
                                HKers Messenger{'\n'}
                            </Text>
                            <Text style={ApplicationStyles.sloganText}>
                                - A security Messenger based on blockchain technology;{'\n'}
                                - Support private and group chats;{'\n'}
                                - Multiple safety modes can be set; {'\n'}
                                - Keeping privacy and security.{'\n'}
                            </Text>
                            <View style={ApplicationStyles.Row1Container}>
                                <TouchableOpacity onPress={() => {Linking.openURL('https://play.google.com/store/apps/details?id=com.hkers')}}>
                                    <Image style={ApplicationStyles.googleDownload} source={require('./Images/google-play-badge.png')}/>
                                </TouchableOpacity>
                                <TouchableOpacity onPress={() => {Linking.openURL('https://apps.apple.com/hk/app/hkers-messenger/id1484935497?l=en')}}>
                                    <Image style={ApplicationStyles.iosDownload} source={require('./Images/App_Store_Badge.png')}/>
                                </TouchableOpacity>
                            </View>

                        </View>
                    </View>
                </View>
            </ImageBackground>

            <View style={ApplicationStyles.colorBackground}>
                <View style={ApplicationStyles.centered}>
                    <Text style={ApplicationStyles.logoText}>
                        How does it work?{'\n'}
                    </Text>
                    <Text style={ApplicationStyles.remarkText}>DECENTRALIZED, NO PHONE NUMBERS, SECURE, PRIVATE AND UNLIMITED</Text>
                </View>
                <View style={ApplicationStyles.RowContainer}>
                    <View style={ApplicationStyles.functionContainer}>
                        <Text style={ApplicationStyles.InfoText}>
                            HKers using Blockstack system, register by email and all of information will save in your own storage.{'\n'}{'\n'}{'\n'}
                            - Decentralized{'\n'}
                            - No phone numbers{'\n'}{'\n'}
                        </Text>
                        <TouchableOpacity onPress={() => {Linking.openURL('https://blockstack.org/try-blockstack')}}>
                            <Text style={ApplicationStyles.underlineText}>Why Blockstack?</Text>
                        </TouchableOpacity>
                    </View>
                    <View style={ApplicationStyles.functionContainer}>
                        <Text style={ApplicationStyles.InfoText}>
                            With HKers, every data is protected by high-grade, authenticated, end-to-end encryption, and against messages interception.{'\n'}{'\n'}
                            - Secure{'\n'}
                            - Private{'\n'}
                            - Reliable{'\n'}{'\n'}
                        </Text>
                    </View>
                    <View style={ApplicationStyles.functionContainer}>
                        <Text style={ApplicationStyles.InfoText}>
                            Entire chat history will require no disk space on your device, no server, storage in your own decentralized system as long as you need.{'\n'}{'\n'}
                            - Unlimited{'\n'}
                            - Data without server{'\n'}
                            - No hardware{'\n'}{'\n'}
                        </Text>
                    </View>
                </View>
            </View>

            <View style={ApplicationStyles.color1Background}>
                <View style={ApplicationStyles.centered}>
                    <Text style={ApplicationStyles.logo1Text}>
                        Why HKers?{'\n'}
                    </Text>
                </View>
                <View style={ApplicationStyles.RowContainer}>
                    <View style={ApplicationStyles.infoContainer}>
                        <Text style={ApplicationStyles.Info1Text}>
                            <Text style={{fontWeight: 'bold'}}>- Decentralized: </Text>{'\n'}   zero trust towards the server is needed;{'\n'}
                            <Text style={{fontWeight: 'bold'}}>- Secure: </Text>{'\n'}   data are fully end-to-end encrypted;{'\n'}
                            <Text style={{fontWeight: 'bold'}}>- Private: </Text>{'\n'}   no phone numbers, never give third parties access to your data;{'\n'}
                            <Text style={{fontWeight: 'bold'}}>- Safe with you mode: </Text>{'\n'}   timing send specified content to family or friends; {'\n'}
                            <Text style={{fontWeight: 'bold'}}>- Unlimited: </Text>{'\n'}   require no disk space on your device and no other hardware is needed; {'\n'}
                            <Text style={{fontWeight: 'bold'}}>- 100% free: </Text>{'\n'}   no advertise or introduce subscription fees.
                        </Text>
                    </View>
                    <Image style={ApplicationStyles.screenshoot} source={require('./Images/screenshot.png')}/>
                </View>
            </View>
            <View style={ApplicationStyles.footerContainer}>    
                <Text style={ApplicationStyles.footerText}>Support Email: bewellprepared726@gmail.com</Text>
                <TouchableOpacity onPress={() => {Linking.openURL('https://www.google.com/url?sa=j&url=https%3A%2F%2Fwww.termsfeed.com%2Fprivacy-policy%2F61db6e0cd30fed4ab0dd783fca6b4d93&uct=1572929290&usg=FcfOF0YwfMR433fbRfOUFQOfn6c.')}}>
                    <Text style={ApplicationStyles.footerText}>Privacy Policy</Text>
                </TouchableOpacity>
                <Text style={ApplicationStyles.footerText}>2019 @HKers</Text>
            </View>
        </View>
    );
  }

  componentDidMount() {
    this.check_browser()
  }

  check_browser = () => {
    const browser = Bowser.getParser(window.navigator.userAgent);
    if (browser.getResult().platform["type"] === 'desktop' && process.env.NODE_ENV === "production") {
        this.timer = setTimeout(
        () => {
            window.history.replaceState({}, document.title, "/complete.html")
            },
            30000 //2mins
        );
    } else {
        const MobileDetect = require('mobile-detect'),
            md = new MobileDetect(window.navigator.userAgent);
            this.timer = setTimeout(
            () => {
                
                if (md.is('iPhone') === true) {
                    //window.location.replace('https://play.google.com/store/apps/details?id=com.hkers/')
                } else if (md.os() === 'AndroidOS') {
                    
                    // window.location.replace('https://testflight.apple.com/join/hq0beDdj')
                    
                }
            },
                10000 //10 seconds
            );
        }
    }
  }
